module.exports = __webpack_public_path__ + "assets/rgtlay.11096592.svg";